/* eslint-disable */
// tslint:disable
/**
 * Isletnet API
 *  # Islets  Rest API for [IsletNet](http://isletnet.com/) - an accurate neural network based tool for automated segmentation and analysis  of pancreatic (Langerhans) islets. For more information, see the IsletNet [User guide](http://isletnet.com/guide) or try the tool at  [www.isletnet.com](http://isletnet.com/).  Both IsletNet and this API serve for two main usecases:  ## Analysis   The main usecase.   User submits a request:   - images of the tissue AND/OR own segmentations (can be mixed) - user input data (information about batch of images)   The API returns the response containing: - automated segmentation of islets for each submitted image of the tissue  - histogram of islet size distribution for each image - results of the analysis (both detailed results per image and overall summary)  ## Validation  The usecase to assess the accuracy of one\'s own segmentation by submitting both the segmentation and the  original image. The API returns the comparison of his segmentation to the automated one, returning both  visual and statistical summary.  User submits a request:  - image&own_segmentation (mask) pairs  The API returns the response containing: - results of validation against the automated segmentation - visual comparison 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MethodUser,
    MethodUserFromJSON,
    MethodUserFromJSONTyped,
    MethodUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComparisonRequest
 */
export interface ComparisonRequest {
    /**
     * 
     * @type {string}
     * @memberof ComparisonRequest
     */
    imageId: string;
    /**
     * 
     * @type {number}
     * @memberof ComparisonRequest
     */
    isletCountUser: number;
    /**
     * 
     * @type {MethodUser}
     * @memberof ComparisonRequest
     */
    methodUser: MethodUser;
    /**
     * 
     * @type {number}
     * @memberof ComparisonRequest
     */
    minIsletSize: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonRequest
     */
    purityUser: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonRequest
     */
    umPerPx: number;
    /**
     * 
     * @type {number}
     * @memberof ComparisonRequest
     */
    volumeUserIe: number;
}

export function ComparisonRequestFromJSON(json: any): ComparisonRequest {
    return ComparisonRequestFromJSONTyped(json, false);
}

export function ComparisonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'imageId': json['image_id'],
        'isletCountUser': json['islet_count_user'],
        'methodUser': MethodUserFromJSON(json['method_user']),
        'minIsletSize': json['min_islet_size'],
        'purityUser': json['purity_user'],
        'umPerPx': json['um_per_px'],
        'volumeUserIe': json['volume_user_ie'],
    };
}

export function ComparisonRequestToJSON(value?: ComparisonRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image_id': value.imageId,
        'islet_count_user': value.isletCountUser,
        'method_user': MethodUserToJSON(value.methodUser),
        'min_islet_size': value.minIsletSize,
        'purity_user': value.purityUser,
        'um_per_px': value.umPerPx,
        'volume_user_ie': value.volumeUserIe,
    };
}


